import styled from "styled-components";

export const MainContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #f7f7f7;
`;

export const PaymentLinkSecondContainer = styled.div`
  width: 100%;
  display: flex;
`;

export const PaymentNavbar = styled.div``;

export const PaymentSidebar = styled.div`
  width: 230px;
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;
